"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Tag_1 = require("./_Tag");
exports._TagSet = {
    type: "list",
    member: {
        shape: _Tag_1._Tag,
        locationName: "Tag"
    }
};
//# sourceMappingURL=_TagSet.js.map